import Vue from 'vue';
import VueFeather from 'vue-feather';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

Vue.component('icon', VueFeather);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
